import { colonyAPI } from '@/api';

import { destructDate } from '@/helpers/date';

import * as types from './mutation-types';
import state from './state';

export default {
  getCharts({ commit }) {
    commit(types.GET_AFSTEREO_CHARTS_REQUEST);

    const data = {
      ...destructDate(state.selectedDate),
      unit: state.selectedPeriod,
    };

    const url = state.selectedStation
      ? `/analytics/afstereo/stats/station/${state.selectedStation}/`
      : '/analytics/afstereo/stats/';

    colonyAPI
      .post(url, data)
      .then(response => commit(types.GET_AFSTEREO_CHARTS_SUCCESS, response))
      .catch(error => commit(types.GET_AFSTEREO_CHARTS_FAILURE, error));
  },

  getStations({ commit }) {
    commit(types.GET_AFSTEREO_STATIONS_REQUEST);

    colonyAPI
      .get('/analytics/afstereo/stations/')
      .then(response => commit(types.GET_AFSTEREO_STATIONS_SUCCESS, response))
      .catch(error => commit(types.GET_AFSTEREO_STATIONS_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/afstereo/actions.js